import { get, set } from "lodash";
import { useTranslation } from "react-i18next";
import { MdOutlineInsertComment } from "react-icons/md";
import Form from "shared/components/Form";
import FormField from "shared/components/FormField";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";

const Information = ({
  initialValues,
  formProps,
  setPercent,
  isFieldRequired,
  bindField,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const INFORMATION = t(
    "SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.INFORMATION",
    {
      returnObjects: true,
    },
  );

  const acceptDocumentsPath = "project.fields.acceptProductDocuments";
  const acceptDocumentsField = bindField(acceptDocumentsPath, {
    label: INFORMATION.MUTUAL_MOBILITY.DOCUMENT_INFOS,
    onChange: () => setPercent(initialValues),
  });

  const commentPath = "project.fields.info.comment";
  const commentField = bindField(commentPath, {
    label: INFORMATION.COMMENT,
    required: isFieldRequired(commentPath),
    onBlur: () => setPercent(initialValues),
  });

  return (
    <div
      className="subscription-form--wrapper"
      id={`${SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.INFORMATION}-section`}
    >
      <Form type="vertical" title={INFORMATION.TITLE}>
        <div className="grid--1">
          <FormField
            path={acceptDocumentsField.path}
            label={acceptDocumentsField.label}
            required={acceptDocumentsField.required}
            disabled={acceptDocumentsField.disabled}
          >
            {(field) => (
              <Input
                type="switch"
                label={acceptDocumentsField.label}
                checked={get(initialValues, acceptDocumentsPath) === true}
                {...field}
                onChange={acceptDocumentsField.onChange}
              />
            )}
          </FormField>
          <FormField
            path={commentField.path}
            label={commentField.label}
            required={commentField.required}
            disabled={commentField.disabled}
          >
            {(field) => (
              <Input
                type="textarea"
                label={commentField.label}
                placeholder={INFORMATION.COMMENT}
                icon={<MdOutlineInsertComment size={16} />}
                normalizeText={true}
                defaultValue={commentField.defaultValue}
                {...field}
                onChange={commentField.onChange}
                onBlur={commentField.onBlur}
                autoSize={{ minRows: 2, maxRows: 10 }}
                optional={!commentField.required}
              />
            )}
          </FormField>
        </div>
      </Form>
    </div>
  );
};

export default Information;
